import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type { Translatable } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    OrderCommandCommon} from "./order-commands-common";
import {
    orderCommandCommonZodSchema,
} from "./order-commands-common";

type OrderCancelCommand = OrderCommandCommon & {
    readonly _type: "ORDER_CANCEL_COMMAND";
    readonly refund: boolean;
    readonly reason?: Translatable;
};

type FactoryParams = Except<OrderCancelCommand, "_id" | "_type" | "_createdAt">;
const orderCancelCommandFactory = (params: FactoryParams) => {
    const orderCancellation: OrderCancelCommand = {
        ...params,
        _id: generateId({ prefix: "order_cancel_command__" }),
        _type: "ORDER_CANCEL_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return orderCancellation;
};

const orderCancelCommandZodSchema: z.ZodSchema<OrderCancelCommand> =
    orderCommandCommonZodSchema.and(
        z.object({
            _type: z.literal("ORDER_CANCEL_COMMAND"),
            refund: z.boolean(),
            reason: z.string().optional(),
        }),
    );

export { orderCancelCommandFactory, orderCancelCommandZodSchema };
export type { OrderCancelCommand };
